// Uses disease IDs from DHIS
export enum Diseases {
  covid19 = 'uYjxkTbwRNf',
  influenza = '9982b8b1',
  blood_donation_screening = 'H8eyuhvDxtX',
}

type Disease = keyof typeof Diseases

// Helper to convert disease name to disease id
export function diseaseNameToId(name: Disease) {
  return Diseases[name]
}

// Helper to convert booking id to disease id
export function bookingIdToDiseaseId(
  name: 'COVID_VACCINE' | 'FLU_VACCINE' | 'BLOOD_DONATION_SCREENING',
) {
  if (name === 'COVID_VACCINE') {
    return diseaseNameToId('covid19')
  }

  if (name === 'FLU_VACCINE') {
    return diseaseNameToId('influenza')
  }

  if (name === 'BLOOD_DONATION_SCREENING') {
    return diseaseNameToId('blood_donation_screening')
  }

  return null
}
